<template>
  <div>
    <Fieldset :legend="$t('searchHeader')" :toggleable="true">
      <div class="p-fluid p-ml-4 p-mr-4 p-justify-center">
        <div class="p-formgrid p-grid p-col-12 p-mt-3">
          <div class="p-col-12 p-lg-6">
            <div class="p-formgrid p-grid">
              <div class="p-field p-col-10">
                <label class="p-mr-2">{{ $t("local_event") }}</label>
                <Button
                  @click="showResponseArea = true"
                  icon="pi pi-plus"
                  class="p-button-success"
                />
              </div>
            </div>
            <span class="p-invalid" v-if="error_table == true">{{
              $t("table_validate")
            }}</span>
            <div class="p-field p-col p-mt-2" style="margin-left: -10px">
              <DataTable
                :value="responseArea_table"
                :scrollable="true"
                  scrollHeight="500px"
                :paginator="true"
                :rows="5"
                dataKey="id"
                :rowHover="true"
                :filters="filters"
                :selection.sync="selectedResponseAreaData"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                :rowsPerPageOptions="[5, 10, 20, 50]"
                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
              >
                <template #empty>{{ $t("TableEmpty") }}</template>
                <Column
                  field="province_name"
                  :header="$t('province')"
                  :sortable="true"
                  headerStyle="width: 15rem"
                >
                  <template #body="dataTable">
                    <div hidden>{{ dataTable.data.tambon_id }}</div>
                    {{ dataTable.data.province_name }}
                  </template>
                </Column>
                <Column
                  field="amphur_name"
                  :header="$t('amphur')"
                  :sortable="true"
                  headerStyle="width: 15rem"
                >
                  <template #body="dataTable">
                    {{ dataTable.data.amphur_name }}
                  </template>
                </Column>
                <Column
                  field="tambon_name"
                  :header="$t('tambon')"
                  :sortable="true"
                  headerStyle="width: 15rem"
                >
                  <template #body="dataTable">
                    {{ dataTable.data.tambon_name }}
                  </template>
                </Column>
                <Column :header="$t('controlTable')" headerStyle="width: 15rem">
                  <template #body="dataTable">
                    <div class="p-formgrid p-grid">
                      <div class="p-field p-col">
                        <Button
                          @click="
                            // displayConfirmation = true;
                            responseAreaDelete = dataTable.data;
                            alertDisplay(responseAreaDelete)
                          "
                          icon="pi pi-trash"
                          :label="$t('deleteBtn')"
                          class="p-button-rounded p-button-danger"
                        />
                      </div>
                    </div>
                  </template>
                </Column>
              </DataTable>
            </div>
          </div>

          <div class="p-col-12 p-lg-6 p-mt-2">
            <div class="p-formgrid p-grid p-col">
              <div class="p-field p-col-12 p-lg-4 p-mt-2">
                <label>{{ $t("month") }}</label>
                <Dropdown
                  v-model="selectedMonth"
                  :options="month"
                  optionLabel="name"
                  id="ds_selectedStartMonth"
                />
              </div>
              <div class="p-field p-col-12 p-lg-2 p-mt-2">
                <label>{{ $t("startYear") }}</label>
                <Dropdown
                  v-model="selectedStartYear"
                  :options="year"
                  optionLabel="name"
                  id="ds_selectedStartYear"
                />
              </div>
              <div class="p-field p-col-12 p-lg-2 p-mt-2">
                <label>{{ $t("endYear") }}</label>
                <Dropdown
                  v-model="selectedEndYear"
                  :options="year"
                  optionLabel="name"
                  id="ds_selectedEndYear"
                />
              </div>
            </div>

            <div class="p-formgrid p-grid p-mt-3 p-col">
              <div class="p-field p-col-12 p-lg-4 p-mt-2">
                <label>{{ $t("disaster_type") }}</label>
                <Dropdown
                  v-model="selectedDisaster"
                  :options="disasterOptions"
                  optionLabel="system_name"
                  :filter="true"
                  :placeholder="$t('placeholderSelectBox')"
                  :clearFilterDropdown="dropdownClearFilerValue"
                >
                  <template #value="disasterOptions">
                    <div v-if="disasterOptions.value">
                      <div>{{ disasterOptions.value.system_name }}</div>
                    </div>
                    <span v-else>
                      {{ disasterOptions.placeholder }}
                    </span>
                  </template>
                  <template #option="disasterOptions">
                    <div class="EV_disasterOptions">{{ disasterOptions.option.system_name }}</div>
                  </template>
                </Dropdown>
              </div>

              <div class="p-field p-col-12 p-lg-3 p-mt-2">
                <label>{{ $t("selectedChart") }}</label>
                <div class="p-formgrid p-grid">
                  <div class="p-field p-col-12">
                    <Dropdown
                      v-model="selectedChart"
                      :options="chartOptions"
                      optionLabel="name"
                      id="ds_selectedChart"
                    />
                  </div>
                </div>
              </div>

              <div class="p-field p-col-12 p-lg-4 ">
                <div class="p-formgrid p-grid p-mt-5 p-jc-end">
                  <Button
                    @click="clearSearchField()"
                    :label="$t('clearBtn')"
                    class="p-button-clear p-mr-3 p-ml-1"
                  />
                  <Button
                    @click="search()"
                    :label="$t('searchBtn')"
                    class="p-button-info"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fieldset>

    <div class="p-grid p-fluid">
      <div class="p-col-12 p-lg-6">
        <div class="card p-fluid p-mt-2">
          <DataTable
            :value="table"
            :scrollable="true"
            scrollHeight="500px"
            :paginator="true"
            :rows="10"
            :rowsPerPageOptions="[10, 20, 50]"
            sortField="tambon_name"
            :sortOrder="1"
            :loading="loading"
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
          >
          <template #empty>{{ $t("TableEmpty") }}</template>
            <Column
              field="tambon_name"
              :header="$t('local_event')"
              headerStyle="width: 200px"
            >
              <template #body="dataTable">
                {{ dataTable.data.tambon_name }}
              </template>
            </Column>
            <div
              v-for="headers in headerYear"
              :key="headerYear.indexOf(headers)"
            >
              <Column :header="headers.toString()" headerStyle="width: 100px">
                <template #body="dataTable">
                  <div v-for="years in year" :key="years.id">
                    <div
                      v-if="
                        years.id == Number(`${headers}`.split('.')[2]) - 543
                      "
                    >
                      <div v-for="months in month" :key="months.id">
                        <div v-if="months.shrt == `${headers}`.split('2')[0]">
                          <div
                            v-for="amount in dataTable.data.amount"
                            :key="JSON.stringify(amount)"
                          >
                            <div
                              v-if="
                                amount.to_char == `${months.id}/${years.id}`
                              "
                            >
                              {{ amount.amount_type }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </Column>
            </div>
          </DataTable>
        </div>
      </div>

      <div class="p-col-12 p-lg-6">
        <div class="card p-mt-2">
          <div class="chartAreaWrapper">
          <h5 class="centerText">{{ $t("TopicGraphReportLocation_Year") }}</h5>
          <span class="centerText">{{ subtopic }}</span>
           <div v-if="selectedChart.value == 'bar' || selectedChart.value == 'line' ">
                 <Chart :type="selectedChart.value" :data="barData" class="walking-speed-chart"/>
                </div>
                <div v-else>
                  <Chart :type="selectedChart.value" :data="pieData" class="walking-speed-chart"/>
                </div>

          <!-- <Chart :type="selectedChart.value" :data="barData" /> -->
        </div>
      </div>
      </div>
    </div>

    <Dialog
      :modal="true"
      :header="$t('ConfirmDelete')"
      :visible.sync="displayConfirmation"
      :style="{ width: '350px' }"
    >
      <div class="confirmation-content p-mt-3">
        <i
          class="pi pi-exclamation-triangle p-mr-3 p-mt2"
          style="font-size: 2rem"
        />
        <span>{{ $t("ConfirmDeleteSub") }}</span>
      </div>
      <template #footer>
        <Button
          :label="$t('cancelBtn')"
          icon="pi pi-times"
          @click="displayConfirmation = false"
          class="p-button-text"
        />
        <Button
          :label="$t('confirmBtn')"
          icon="pi pi-check"
          @click="confirmDelete()"
          class="p-button-text"
          autofocus
        />
      </template>
    </Dialog>

    <Dialog
      :modal="true"
      header="ค้นหาข้อมูลพื้นที่เกิดเหตุ"
      :visible.sync="showResponseArea"
      :style="{ width: '80%' }"
      :contentStyle="{ 'overflow-y': 'scroll' }"
    >
      <response-area-table
        @selectResponseArea="selectResponseArea_passValue"
        :parentmessage="parentmessage_area"
      ></response-area-table>
    </Dialog>
  </div>
</template>

<script>
import responseAreaTable from "../ResponseAreaTable";

export default {
  name: "statistic-location-year",
  components: {
    responseAreaTable,
  },
  data() {
    return {
      dropdownClearFilerValue:0,
      month: this.$month,
      year: [],

      selectedMonth: null,
      selectedStartYear: null,
      selectedEndYear: null,

      filters: {},
      table: [],
      barData: {},
      pieData: {},
      headerYear: [],

      disasterOptions: [],
      selectedDisaster: null,

      chartOptions: [],
      selectedChart: { id: 1, name: "แบบ Bar", value: "bar" },

      subtopic: "",

      displayConfirmation: false,
      showResponseArea: false,
      responseArea_table: [],
      responseAreaDelete: null,
      error_table: false,

      selectedResponseAreaData: null,

      range_arr: [],
      label: [],

      parentmessage_area: null,

      loading:false,
    };
  },

  watch: {
    showResponseArea(val) {
      if (val == true) {
        // console.log(this.responseArea_table);
        if (this.responseArea_table.length > 0) {
          this.parentmessage_area = this.responseArea_table;
        } else {
          this.parentmessage_area = [];
        }
      }
    },

    disasterOptions(val) {
      if (val != null) {
        this.selectedDisaster = {
          system_id: this.disasterOptions[0].system_id,
          system_name: this.disasterOptions[0].system_name,
        };
      }
    },

    responseArea_table(val) {
      if (val.length > 0) {
        this.error_table = false;
      }
    },

    table(val) {
      if (val.length != 0) {
        var letters = "0123456789ABCDEF";
        var color = "#";
        var dataset = [];
        var result = [];
        var resultPie = [];

        for (let i = 0; i < val.length; i++) {
          if (val[i].amount == "0") {
            result.push(val[i].amount);
          } else {
            for (let j = 0; j < val[i].amount.length; j++) {
              result.push(val[i].amount[j]);
            }
          }
        }

        for (let i = 0; i < val.length; i++) {
              resultPie.push({tambon_name: `${val[i].tambon_name}`,amount_type : 0 });
        }

for (let i = 0; i < val.length; i++) {
          for (let j = 0; j < val[i].amount.length; j++) {
            if (val[i].tambon_name == val[i].amount[j].tambon_name) {
              // console.log('val[i].tambon_name = ',val[i].tambon_name);
              // console.log('val[i].amount[j].tambon_name = ',val[i].amount[j].tambon_name);
              resultPie[i].amount_type = Number(resultPie[i].amount_type) + Number(val[i].amount[j].amount_type);

            } 
            // console.log('val[i].amount.data[j] = ',val[i].amount.data[j]);
          }
        }
        // console.log('resultPie = ',resultPie);



        var all_amount = [];

        for (let t = 0; t < val.length; t++) {
          for (let i = 0; i < this.range_arr.length; i++) {
            for (let j = 0; j < result.length; j++) {
              if (this.range_arr[i] == result[j].to_char) {
                if (val[t].tambon_id == result[j].location_id) {
                  all_amount.push(`${result[j].amount_type}`);
                } else {
                  all_amount.push("0");
                }
              } else {
                all_amount.push("0");
              }
            }
          }
        }
        var number = [];
        var index;
        var all = [];
        for (let j = 0; j < val.length; j++) {
          for (let i = 1; i <= this.range_arr.length; i++) {
            index = i * result.length;
            var temp = 0;
            for (let k = index - result.length; k < index; k++) {
              temp += Number(all_amount[k]);
            }
            number.push(temp);
          }
          all_amount = all_amount.slice(index);
          all.push({ id: number });
          number = [];
        }
//datasets of barData
        for (let j = 0; j < val.length; j++) {
          for (let k = 0; k < 6; k++) {
            color += letters[Math.floor(Math.random() * 16)];
          }
          dataset.push({
            label: `${val[j].tambon_name}`,
            backgroundColor: `${color}`,
            borderColor: `${color}`,
            data: all[j].id,
          });
          color = "#";
        }

        this.barData = {
          labels: this.label,
          datasets: dataset,
        };

//datasets of pieData
      var labelPie = [];
      var colorPie = [];
      var dataPie = [];
        for (let j = 0; j < val.length; j++) {

          labelPie.push(`${resultPie[j].tambon_name}`);
            for (let k = 0; k < 6; k++) {
              color += letters[Math.floor(Math.random() * 16)];
            }
            colorPie.push(`${color}`);
            dataPie.push(resultPie[j].amount_type);
            color = "#";
        }

        // console.log('datasetPieData = ',datasetPieData);
        // console.log('labelPie = ',labelPie);
        // console.log('colorPie = ',colorPie);
        // console.log('dataPie = ',dataPie);

        this.pieData = {
          labels: labelPie,
          datasets: [
                    {
                        data: dataPie,
                        backgroundColor: colorPie,
                        hoverBackgroundColor: colorPie
                    }
                ],
        };



      }
    },
  },
  async created() {
    this.table = [];
    this.chartOptions.push({ id: 1, name: "แบบ Bar", value: "bar" });
    this.chartOptions.push({ id: 2, name: "แบบ Pie", value: "pie" });
    this.chartOptions.push({ id: 3, name: "แบบ Line", value: "line" });
    this.chartOptions.push({ id: 4, name: "แบบ Doughnut", value: "doughnut" });

    await this.axios
      .post(`${this.$url_service}/initial/option`, {
        body: { group: "dg-02" },
      })
      .then((response) => {
        this.disasterOptions = response.data.data;
      });
    this.selectedMonth = { id: "01", name: "มกราคม", shrt: "ม.ค." };

    var current_year = new Date().getFullYear();
    this.selectedStartYear = {
      id: `${current_year}`,
      name: `${current_year + 543}`,
    };
    this.selectedEndYear = {
      id: `${current_year}`,
      name: `${current_year + 543}`,
    };
    for (let i = 0; i < 12; i++) {
      this.year.push({ id: `${current_year}`, name: `${current_year + 543}` });
      current_year--;
    }
  },
  mounted() {},
  methods: {
    selectResponseArea_passValue(variable) {
      this.showResponseArea = false;
      if (variable != null) {
        this.responseArea_table = [];
        for (let i = 0; i < variable.length; i++) {
          this.responseArea_table.push(variable[i]);
        }
      }
    },

    confirmDelete() {
      this.responseArea_table = this.responseArea_table.filter(
        (val) => val !== this.responseAreaDelete
      );
      this.displayConfirmation = false;
      this.responseAreaDelete = null;
    },

    search() {
      this.table = [];
      this.headerYear = [];
      this.barData = {};
      this.pieData = {}
      this.range_arr = [];
      this.label = [];
      this.subtopic = ""
      if (this.responseArea_table.length == 0) {
        this.error_table = true;
      } else {
        if (this.selectedStartYear.id <= this.selectedEndYear.id) {
          this.setHeader();
        }
      }
    },

    async setHeader() {
      this.range_arr = [];
      this.table = [];
      this.headerYear = [];
      this.label = [];
      this.subtopic = `เดือน${this.selectedMonth.name} ปี ${this.selectedStartYear.name} ถึง ${this.selectedEndYear.name} | ประเภทสาธารณภัย : ${this.selectedDisaster.system_name}`;
      if (this.selectedStartYear.id == this.selectedEndYear.id) {
        this.headerYear.push([
          `${this.selectedMonth.shrt}${this.selectedStartYear.name}`,
        ]);
        this.label.push(
          `${this.selectedMonth.shrt}${this.selectedStartYear.name}`
        );
        this.range_arr.push(
          `${this.selectedMonth.id}/${this.selectedStartYear.id}`
        );
      } else {
        var startY = Number(this.selectedStartYear.id);
        var endY = Number(this.selectedEndYear.id);
        var diff_year = endY - startY - 1;
        if (diff_year == 0) {
          this.headerYear.push([
            `${this.selectedMonth.shrt}${this.selectedStartYear.name}`,
          ]);
          this.headerYear.push([
            `${this.selectedMonth.shrt}${this.selectedEndYear.name}`,
          ]);
          this.label.push(
            `${this.selectedMonth.shrt}${this.selectedStartYear.name}`
          );
          this.label.push(
            `${this.selectedMonth.shrt}${this.selectedEndYear.name}`
          );
          this.range_arr.push(
            `${this.selectedMonth.id}/${this.selectedStartYear.id}`
          );
          this.range_arr.push(
            `${this.selectedMonth.id}/${this.selectedEndYear.id}`
          );
        } else {
          var year_range = [this.selectedStartYear.id, this.selectedEndYear.id];
          for (let i = 0; i < diff_year; i++) {
            var check = `${Number(year_range[i]) + 1}`;
            year_range.splice(i + 1, 0, check);
          }
          // console.log(year_range);
          this.headerYear.push([
            `${this.selectedMonth.shrt}${this.selectedStartYear.name}`,
          ]);
          this.label.push(
            `${this.selectedMonth.shrt}${this.selectedStartYear.name}`
          );
          this.range_arr.push(
            `${this.selectedMonth.id}/${this.selectedStartYear.id}`
          );

          for (let j = 1; j < year_range.length - 1; j++) {
            this.headerYear.push([
              `${this.selectedMonth.shrt}${Number(year_range[j]) + 543}`,
            ]);
            this.label.push(
              `${this.selectedMonth.shrt}${Number(year_range[j]) + 543}`
            );
            this.range_arr.push(
              `${this.selectedMonth.id}/${Number(year_range[j])}`
            );
          }
          this.headerYear.push([
            `${this.selectedMonth.shrt}${this.selectedEndYear.name}`,
          ]);
          this.label.push(
            `${this.selectedMonth.shrt}${this.selectedEndYear.name}`
          );
          this.range_arr.push(
            `${this.selectedMonth.id}/${this.selectedEndYear.id}`
          );
        }
      }
      this.loading = true;
      await this.axios
        .post(`${this.$url_service}/get/statistic`, {
          body: {
            topic: "get-location-year",
            month: this.selectedMonth.id,
            start_year: this.selectedStartYear.id,
            end_year: this.selectedEndYear.id,
            type: this.selectedDisaster.system_id,
            location: this.responseArea_table,
          },
        })
        .then((response) => {
          // console.log(response.data.data), 
          (this.table = response.data.data);
        });
        this.loading = false;
    },

    clearSearchField() {
      this.dropdownClearFilerValue +=1;
      this.table = [];
      this.headerYear = [];
      this.error_table = false;
      this.responseArea_table = [];
    },
    alertDisplay(temp) {
      this.$fire({
                    title: "ยืนยันการลบข้อมูล",
                    text: "คุณต้องการลบข้อมูลนี้ใช่หรือไม่ ?",
                    
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'ตกลง',
                    cancelButtonText:'ยกเลิก',
                  }).then((result) => {
                    // console.log(temp)
                    if (result.value) {
                      // console.log(temp)
                      this.confirmDelete(temp)
                    }
                  })
    },
  },
  computed: {},
};
</script>

<style scoped lang="scss">
@media screen and (max-width: 430px) {
  .EV_disasterOptions{
  width: 14.5rem;
  overflow-y:scroll;
  }
  .EV_disasterOptions::-webkit-scrollbar {
    width: 0;
    height: 1px;
    
  }

  .EV_disasterOptions::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.1); 
      
      
  }

  .EV_disasterOptions::-webkit-scrollbar-thumb {
      
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.2); 
      
  }
}
.p-multiselect {
  min-width: 15rem;
}

.multiselect-custom {
  .p-multiselect-label:not(.p-placeholder) {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }

  .item {
    display: flex;
    align-items: center;
  }

  .item-value {
    padding-left: 10px;
    padding-right: 10px;
    border-radius: 3px;
    display: inline-flex;
    margin-right: 0.5rem;
    background-color: var(--primary-color);
    color: var(--primary-color-text);
  }
}
</style>

<style scoped>
.p-field {
  margin-bottom: 0rem;
}
</style>


<style>
  /* ! ส่วนกราฟ */
  .chartAreaWrapper {
         width: 100%;
         overflow-x: scroll;
    }
  
  .walking-speed-chart{
         /* margin-top: 20px; */
         height: 80%;
         width: 880px;
    }
  
  
    @media screen and (max-width: 1540px) {
      .walking-speed-chart{
         height: 80%;
         width: 690px;
    }
  
  }
  
  /* ! จบส่วนกราฟ */
  </style>